var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emoji-picker"},[_c('button',{staticClass:"small",on:{"click":_vm.togglePicker}},[_vm._v("+")]),(_vm.isPickerOpen)?_c('div',{staticClass:"picker"},_vm._l((_vm.emojis),function(emoji){return _c('span',{key:emoji,on:{"!click":function($event){return _vm.selectEmoji(emoji)}}},[_c('p',[_vm._v(_vm._s(emoji))])])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }